import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useCartStore = create(
  persist(
    (set, get) => ({
      sessionId: Math.random().toString(36).substring(7),
      items: [],
      
      addItem: (product, size, color = 'Standard', variantId = null, quantity = 1) => {
        const items = get().items;
        const existingIndex = items.findIndex(
          item => item.product.id === product.id && 
                  item.size === size && 
                  item.color === color &&
                  item.variantId === variantId
        );
        
        if (existingIndex > -1) {
          const newItems = [...items];
          newItems[existingIndex].quantity += quantity;
          set({ items: newItems });
        } else {
          set({ items: [...items, { product, size, color, variantId, quantity }] });
        }
      },
      
      removeItem: (productId, size, color = 'Standard', variantId = null) => {
        set({ items: get().items.filter(item => 
          !(item.product.id === productId && 
            item.size === size && 
            item.color === color &&
            item.variantId === variantId)
        )});
      },
      
      updateQuantity: (productId, size, color = 'Standard', variantId = null, quantity) => {
        const items = get().items;
        const index = items.findIndex(
          item => item.product.id === productId && 
                  item.size === size && 
                  item.color === color &&
                  item.variantId === variantId
        );
        if (index > -1) {
          const newItems = [...items];
          newItems[index].quantity = quantity;
          set({ items: newItems });
        }
      },
      
      clearCart: () => set({ items: [] }),
      
      getTotal: () => {
        return get().items.reduce((total, item) => {
          const price = item.product.discount_price || item.product.price;
          return total + (price * item.quantity);
        }, 0);
      },
      
      getItemCount: () => {
        return get().items.reduce((count, item) => count + item.quantity, 0);
      }
    }),
    {
      name: 'cart-storage',
    }
  )
);

export default useCartStore;